import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { fadeInUp, slideInLeft } from '../../utils/animations';
import './Hero.css';
import './HeroIndicators.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const slides = [
    {
      id: 1,
      title: <>Clarity, Structure,<span className="hero-highlight"> Disciplined Execution</span></>,
      desc: "Triology Business Labs partners with growth-stage organizations to bring clarity to leadership intent, structure to systems, and discipline to execution enabling sustainable, aligned growth.",
      cta: "Let’s Begin the Transformation →",
      link: "/services",
      isHash: false,
      video: "/HomeBanner.mp4"
    },
    {
      id: 2,
      title: <>When Growth Outpaces Systems, <span className="hero-highlight">Execution Suffers</span></>,
      desc: "We help leadership teams realign strategy, systems, and execution before scaling further.",
      cta: "Explore Our Approach",
      link: "/our-approach",
      isHash: false,
      video: "/Growth.mp4"
    },
    {
      id: 3,
      title: <>Clarity Creates Alignment - <span className="hero-highlight">Alignment Enables Execution</span></>,
      desc: "Triology Business Labs partners with organizations to build systems that sustain growth.",
      cta: "Explore COSMOS",
      link: "/cosmos",
      isHash: false,
      video: "/Cliarity.mp4"
    }
  ];

  const videoRef = React.useRef(null);

  React.useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [currentSlide]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const handleLinkClick = (e, link, isHash) => {
    if (isHash) {
      e.preventDefault();
      const element = document.querySelector(link);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="hero">
      <div className="hero-video-container">
        <video
          ref={videoRef}
          key={slides[currentSlide].video}
          autoPlay
          loop
          muted
          playsInline
          className="hero-background-video"
        >
          <source src={slides[currentSlide].video} type="video/mp4" />
        </video>
      </div>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <AnimatePresence mode='wait'>
            <motion.div
              key={currentSlide}
              className="hero-text"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.5 }}
            >
              <motion.h1 variants={fadeInUp}>
                {slides[currentSlide].title}
              </motion.h1>
              <motion.p variants={fadeInUp}>
                {slides[currentSlide].desc}
              </motion.p>
              <motion.div className="hero-buttons" variants={fadeInUp}>
                {slides[currentSlide].isHash ? (
                  <a
                    href={slides[currentSlide].link}
                    onClick={(e) => handleLinkClick(e, slides[currentSlide].link, true)}
                    style={{ textDecoration: 'none' }}
                  >
                    <Button variant="secondary" size="large" className="hero-btn-secondary">
                      {slides[currentSlide].cta}
                    </Button>
                  </a>
                ) : (
                  <Link to={slides[currentSlide].link}>
                    <Button variant="secondary" size="large" className="hero-btn-secondary">
                      {slides[currentSlide].cta}
                    </Button>
                  </Link>
                )}
              </motion.div>
            </motion.div>
          </AnimatePresence>

          <div className="hero-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`hero-dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
